import type { ScheduleComponent } from '@syncfusion/ej2-react-schedule'

export function canRefreshScheduleEvents(schedule: ScheduleComponent | null): boolean {
  if (!schedule) return false

  const root = schedule as unknown as {
    isDestroyed?: boolean
    activeView?: { startDate?: () => Date }
  }

  return !root.isDestroyed && !!root.activeView && typeof root.activeView.startDate === 'function'
}

export function safeRefreshScheduleEvents(schedule: ScheduleComponent | null): boolean {
  if (!canRefreshScheduleEvents(schedule)) return false

  try {
    schedule.refreshEvents(false)
    return true
  } catch {
    /* view not fully initialized */
    return false
  }
}

export function revertScheduleDomChange(schedule: ScheduleComponent | null): void {
  if (!schedule) return

  const crudObj = (
    schedule as unknown as {
      crudModule?: {
        crudObj?: { isCrudAction: boolean; sourceEvent: unknown; targetEvent: unknown }
      }
    }
  ).crudModule?.crudObj

  if (crudObj) {
    crudObj.isCrudAction = false
    crudObj.sourceEvent = null
    crudObj.targetEvent = null
  }

  safeRefreshScheduleEvents(schedule)
}
